import { useState } from 'react';

/**
 * Hook para sincronizar estado con API
 * Proporciona métodos para agregar, actualizar y eliminar items
 * Sin necesidad de recargar la lista
 * 
 * Uso:
 * const { data, setData, addItem, updateItem, deleteItem } = useDataSync([]);
 */
export const useDataSync = (initialData = []) => {
  const [data, setData] = useState(initialData);

  /**
   * Agrega un nuevo item al array
   * @param {object} newItem - Item a agregar
   */
  const addItem = (newItem) => {
    setData(prev => [...prev, newItem]);
  };

  /**
   * Actualiza un item existente
   * @param {number|string} id - ID del item
   * @param {object} updatedFields - Campos a actualizar
   */
  const updateItem = (id, updatedFields) => {
    setData(prev => prev.map(item => 
      item.id === id ? { ...item, ...updatedFields } : item
    ));
  };

  /**
   * Elimina un item del array
   * @param {number|string} id - ID del item a eliminar
   */
  const deleteItem = (id) => {
    setData(prev => prev.filter(item => item.id !== id));
  };

  return { data, setData, addItem, updateItem, deleteItem };
};